import { IDialogAction } from './IDialogAction';
import { DialogState } from '../models/DialogState';
import { DialogUser } from '../models/feed/DialogUser';
import { DialogComment } from '../models/feed/DialogComment';

export const ADD_MESSAGE = 'ADD_MESSAGE';

export class AddMessageAction implements IDialogAction {
    public readonly type = ADD_MESSAGE;
    public constructor(public payload: any) {}
    public reducer(state: DialogState): DialogState {
        this.payload.messages.forEach((m: any) => {
            let messageMeta = JSON.parse(m.m);
            if(messageMeta.allowLikes === undefined) {
                messageMeta.allowLikes = true;
            }
            if(messageMeta.allowComments === undefined) {
                messageMeta.allowComments = true;
            }
            state.feed.messages.push({
                id: m.i,
                sequence: m.sq,
                actionRequired: m.ar,
                readItLater: m.ril,
                title: m.t,
                intro: m.n,
                url: m.u,
                externalUrl: m.x,
                description: m.d,
                posted: new Date(m.p + '.000Z'),
                categoryId: m.c,// || '3ad3dec6-1599-4666-b437-5a7a88449086',
                audiences: m.as.map((a: any) => { return {
                    id: a.i,
                    name: a.n
                }}),
                //audiences:[],
                liked: m.il,
                likes: this._mapLikes(m.lks),
                comments: this._mapComments(m.cmts).sort((a, b) => a.posted.valueOf() - b.posted.valueOf()),
                allowComments: this.payload.globalComments && messageMeta.allowComments,
                allowLikes: this.payload.globalLikes && messageMeta.allowLikes,
                //editUrl: './#mid=' + m.i
                //editUrl: './message-center/#mid=' + m.i
            });
        });
        return state;
    }
    private _mapComments(cmts: any[]): DialogComment[] {
        if(cmts) {
            return cmts.map(c => { 
                return {
                    id: c.i,
                    text: c.t,
                    author: {
                        id: '',
                        externalId: c.l,
                        name: c.a,
                        profileUrl: `/_layouts/15/me.aspx?p=${c.l}`,
                        profilePhotoUrl: `/_layouts/15/userphoto.aspx?size=M&accountname=i%3A0%23.f%7Cmembership%7C${encodeURIComponent(c.l)}`
                    },
                    posted: new Date(c.p + '.000Z'),
                    liked: c.icl,
                    likes: this._mapLikes( c.lks ),
                    comments: this._mapComments( c.cmts )
                }
            });
        }
        return [];
    }
    private _mapLikes(lks: any[]): DialogUser[] {
        if(lks) {
            return lks.map(l => {
                return {
                    id: l.i,
                    externalId: l.x,
                    name: l.u,
                    profileUrl: `/_layouts/15/me.aspx?p=${l.x}`,
                    profilePhotoUrl: `/_layouts/15/userphoto.aspx?size=M&accountname=i%3A0%23.f%7Cmembership%7C${encodeURIComponent(l.x)}`
                }
            });
        }
        return [];
    }
}

export const AddMessageActionTypeMapping = {
    [ADD_MESSAGE]: AddMessageAction
};